import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

export default function ImageCard({ image }) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
      }}
    />
  );
}

ImageCard.propTypes = {
  image: PropTypes.string.isRequired,
};
